import type { JobCharacteristic } from './job-characteristic.interface';

export interface cv_IACUCProtocol {
    Abbreviation: string;
    C_IACUCProtocol_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IACUCProtocol: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    JobCharacteristic: JobCharacteristic[];
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
